import { render, staticRenderFns } from "./ComponentGuide.vue?vue&type=template&id=2424b2f2&scoped=true&"
import script from "./ComponentGuide.vue?vue&type=script&lang=js&"
export * from "./ComponentGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424b2f2",
  null
  
)

export default component.exports